module.exports = __webpack_public_path__ + "img/about-children-bg@mb.9900dbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-children-bg@mb.png
// module id = mqvo
// module chunks = 2